// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import { Address, type AddressWireFormat, NewAddress } from '../Address/Address';

export class ProjectMapPin {
  readonly id: string;
  readonly name: string;
  readonly statusId: string;
  readonly address: Address;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.statusId = data.statusId === undefined ? NIL_UUID : data.statusId;
    this.address = NewAddress(data.address);
  }

  static zero(): ProjectMapPin {
    const zeroValues: ExcludeMethodsDeep<ProjectMapPin> = {
      id: NIL_UUID,
      name: '',
      statusId: NIL_UUID,
      address: Address.zero(),
    };
    return new ProjectMapPin(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type ProjectMapPinWireFormat = {
  id: string;
  name: string;
  statusId: string;
  address: AddressWireFormat;
};

type NewProjectMapPinProps = PartialDeep<ProjectMapPin, { recurseIntoArrays: true }>;
export const NewProjectMapPin: (props: NewProjectMapPinProps) => ProjectMapPin = (props) =>
  new ProjectMapPin(props);

type NewProjectMapPinFromWireFormatProps = PartialDeep<
  ProjectMapPinWireFormat,
  { recurseIntoArrays: true }
>;
export const NewProjectMapPinFromWireFormat: (
  props: NewProjectMapPinFromWireFormatProps,
) => ProjectMapPin = (props) => new ProjectMapPin(props);
